(function () {
  function boot(root) {
    if (!root || root.dataset.saReady) return;
    root.dataset.saReady = '1';

    var form = root.querySelector('[data-sa-form]');
    var success = root.querySelector('[data-sa-success]');
    var errors = root.querySelector('[data-sa-errors]');
    var submitBtn = root.querySelector('[data-sa-submit]');
    var desk = (root.getAttribute('data-review-desk-url') || '').trim();

    root.querySelectorAll('[data-sa-type]').forEach(function (el) {
      el.addEventListener('click', function () {
        var input = el.querySelector('input[type="checkbox"]');
        if (!input) return;
        setTimeout(function () {
          el.classList.toggle('is-selected', input.checked);
        }, 0);
      });
    });

    function get(sel) {
      var el = root.querySelector(sel);
      return el ? String(el.value || '').trim() : '';
    }

    function normalizeWebsite(raw) {
      var v = (raw || '').trim();
      if (!v) return '';
      // allow www.example.com / example.com without https
      if (!/^https?:\/\//i.test(v)) v = 'https://' + v;
      return v;
    }

    function typesValue() {
      var checked = [];
      root.querySelectorAll('input[name="sa_types"]:checked').forEach(function (i) {
        checked.push(i.value);
      });
      return checked.join(', ');
    }

    function payload() {
      return {
        shop_name: get('[data-sa-shop]'),
        types: typesValue(),
        address: get('[data-sa-address]'),
        city: get('[data-sa-city]'),
        state: get('[data-sa-state]'),
        zip: get('[data-sa-zip]'),
        country: get('[data-sa-country]'),
        phone: get('[data-sa-phone]'),
        contact_name: get('[data-sa-contact]'),
        email: get('[data-sa-email]'),
        website: normalizeWebsite(get('[data-sa-website]')),
        hours: get('[data-sa-hours]'),
        note: get('[data-sa-note]')
      };
    }

    function showError(msg) {
      if (!errors) {
        alert(msg);
        return;
      }
      errors.hidden = false;
      errors.textContent = msg;
      errors.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    function showSuccess() {
      if (form) form.hidden = true;
      if (success) success.hidden = false;
      var note = root.querySelector('[data-sa-floor-note]');
      if (note) note.hidden = true;
      var s1 = root.querySelector('[data-sa-step1-pill]');
      if (s1) {
        s1.classList.remove('is-active');
        s1.classList.add('is-done');
      }
      if (success) success.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Reliable Apps Script submit: form POST into hidden iframe (avoids CORS / redirect loss)
    function postToDesk(data) {
      return new Promise(function (resolve, reject) {
        if (!desk) {
          reject(new Error('Missing review desk URL'));
          return;
        }
        var iframe = root.querySelector('iframe[name="cemotoSaSink"]') || document.querySelector('iframe[name="cemotoSaSink"]');
        if (!iframe) {
          iframe = document.createElement('iframe');
          iframe.name = 'cemotoSaSink';
          iframe.title = 'submit';
          iframe.style.cssText = 'display:none;width:0;height:0;border:0';
          document.body.appendChild(iframe);
        }

        var temp = document.createElement('form');
        temp.method = 'POST';
        temp.action = desk;
        temp.target = 'cemotoSaSink';
        temp.style.display = 'none';

        Object.keys(data).forEach(function (key) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = data[key] == null ? '' : String(data[key]);
          temp.appendChild(input);
        });

        document.body.appendChild(temp);

        var settled = false;
        function done() {
          if (settled) return;
          settled = true;
          try { document.body.removeChild(temp); } catch (e) {}
          resolve(true);
        }

        // Apps Script often redirects; iframe load = request accepted
        var timer = setTimeout(done, 2500);
        iframe.addEventListener('load', function onLoad() {
          iframe.removeEventListener('load', onLoad);
          clearTimeout(timer);
          done();
        });

        try {
          temp.submit();
        } catch (err) {
          clearTimeout(timer);
          try { document.body.removeChild(temp); } catch (e2) {}
          reject(err);
        }
      });
    }

    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (errors) {
        errors.hidden = true;
        errors.textContent = '';
      }

      if (!typesValue()) {
        showError('Please select at least one: Sales, Test Ride, or Service.');
        return;
      }

      var agree = root.querySelector('[data-sa-agree]');
      if (agree && !agree.checked) {
        showError('Please confirm this is a real retail / service location.');
        return;
      }

      var email = get('[data-sa-email]');
      if (!email || email.indexOf('@') < 1) {
        showError('Please enter a valid email — we use it to send approval notices.');
        var emailEl = root.querySelector('[data-sa-email]');
        if (emailEl) emailEl.focus();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      if (!desk) {
        showError('Review desk is not configured. Please contact CEMOTO.');
        return;
      }

      var data = payload();
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }

      postToDesk(data)
        .then(function () {
          showSuccess();
        })
        .catch(function () {
          showError('Could not reach the review desk. Check your connection and try again.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Submit for review';
          }
        });
    });

    if (submitBtn && !submitBtn.getAttribute('data-label')) {
      submitBtn.setAttribute('data-label', submitBtn.textContent);
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-cemoto-store-application]').forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
